import Config from "../config/Configs";

// Sample page constants
export const SAMPLE_FETCH_DATA = 'SAMPLE:FETCH_DATA'
export const SAMPLE_DATA_LOADING = 'SAMPLE:DATA_LOADING'
export const SAMPLE_DATA_LOADED = 'SAMPLE:DATA_LOADED'
export const SAMPLE_DATA_ERROR = 'SAMPLE:DATA_ERROR'
export const SAMPLE_LAUNCH_BOOK = 'SAMPLE:LAUNCH_BOOK'
export const SAMPLE_BUY_BOOK = 'SAMPLE:BUY_BOOK'
export const SAMPLE_PRIMARY_TOGGLE = 'SAMPLE:PRIMARY_TOGGLE'
export const SAMPLE_SEARCH = 'SAMPLE:SEARCH'
export const SAMPLE_FILTER_APPLY = 'SAMPLE:FILTER_APPLY'

//Language
export const LANGUAGE_UPDATE = 'LANGUAGE:UPDATE'

//Digital download
export const ACCESS_CODE_LOADING = 'ACCESS_CODE:VALIDATE'
export const ACCESS_CODE_CORRECT = 'ACCESS_CODE:CORRECT'
export const ACCESS_CODE_INCORRECT = 'ACCESS_CODE:INCORRECT'
export const ACCESS_CODE_ERROR = 'ACCESS_CODE:ERROR'

export const DOWNLOAD_LOADING = 'DOWNLOAD:LOADING'
export const DOWNLOAD_SUCCESS = 'DOWNLOAD:SUCCESS'
export const DOWNLOAD_ERROR = 'DOWNLOAD:ERROR'
export const DIGITAL_DOWNLOAD_RESET = 'DOWNLOAD:RESET'

export const SERVICE_HEADER = {
    'Content-Type': 'application/json;charset=utf-8',
    'apiKey': Config.apiKey
}